export const text = {
  en: {
    'queue-lang': 'Queue',
    'watched-lang': 'Watched',
    'zsu': 'Support Ukraine',
    'genr-lang': 'Genres',
    'year-lang': 'Year',
    'year-chose': 'year',
    'all-genres-lang': 'all genres',
    'home': 'HOME',
    'library': 'MY LIBRARY',
    'log-lang': 'Log in',
    "log-out": "Log out",
  }
  , ua: {
    'queue-lang': 'В черзі',
    'watched-lang': 'Переглянуті',
    'zsu': 'Допомога ЗСУ',
    'genr-lang': 'Жанри',
    'year-lang': 'Рік',
    'year-chose': 'рік',
    'all-genres-lang': 'всі жанри',
    'home': 'ГОЛОВНА',
    'library': 'МОЯ БІБЛІОТЕКА',
    'log-lang': 'УВІЙТИ',
    "log-out": "ВИЙТИ",
  }
};